import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { getEvent as universalGetEvent, listEvents as universalListEvents, queryEvents as universalQueryEvents, createEvent as universalCreateEvent, bulkCreateEvent as universalBulkCreateEvent, updateEvent as universalUpdateEvent, bulkUpdateEvent as universalBulkUpdateEvent, restoreEventDefaults as universalRestoreEventDefaults, splitRecurringEvent as universalSplitRecurringEvent, cancelEvent as universalCancelEvent, bulkCancelEvent as universalBulkCancelEvent, listEventsByContactId as universalListEventsByContactId, listEventsByMemberId as universalListEventsByMemberId, } from './calendar-v3-event.universal';
import { Status, RecurrenceType, Frequency, Day, Transparency, LocationType, Role, ParticipantsStatus, Type, Field, IdentityType, RequestedFields, SortOrder, WebhookIdentityType, PlacementType, DayOfWeek, ResolutionMethod, } from './calendar-v3-event.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.calendar.v3.event', module_name: 'wix-calendar.v3' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        getEvent: (eventId, options) => {
            const methodLogData = {
                method_name: 'getEvent',
                service_name: 'wix.calendar.events.v3.EventsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-calendar.v3,entity=wix.calendar.v3.event,environment=velo-frontend,method-fqn=wix.calendar.events.v3.EventsService.getEvent',
            };
            return universalGetEvent(eventId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listEvents: (eventIds, options) => {
            const methodLogData = {
                method_name: 'listEvents',
                service_name: 'wix.calendar.events.v3.EventsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-calendar.v3,entity=wix.calendar.v3.event,environment=velo-frontend,method-fqn=wix.calendar.events.v3.EventsService.listEvents',
            };
            return universalListEvents(eventIds, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryEvents: (options) => {
            const methodLogData = {
                method_name: 'queryEvents',
                service_name: 'wix.calendar.events.v3.EventsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-calendar.v3,entity=wix.calendar.v3.event,environment=velo-frontend,method-fqn=wix.calendar.events.v3.EventsService.queryEvents',
            };
            return universalQueryEvents(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        createEvent: (event, options) => {
            const methodLogData = {
                method_name: 'createEvent',
                service_name: 'wix.calendar.events.v3.EventsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-calendar.v3,entity=wix.calendar.v3.event,environment=velo-frontend,method-fqn=wix.calendar.events.v3.EventsService.createEvent',
            };
            return universalCreateEvent(event, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkCreateEvent: (events, options) => {
            const methodLogData = {
                method_name: 'bulkCreateEvent',
                service_name: 'wix.calendar.events.v3.EventsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-calendar.v3,entity=wix.calendar.v3.event,environment=velo-frontend,method-fqn=wix.calendar.events.v3.EventsService.bulkCreateEvent',
            };
            return universalBulkCreateEvent(events, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateEvent: (_id, event, options) => {
            const methodLogData = {
                method_name: 'updateEvent',
                service_name: 'wix.calendar.events.v3.EventsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-calendar.v3,entity=wix.calendar.v3.event,environment=velo-frontend,method-fqn=wix.calendar.events.v3.EventsService.updateEvent',
            };
            return universalUpdateEvent(_id, event, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUpdateEvent: (events, options) => {
            const methodLogData = {
                method_name: 'bulkUpdateEvent',
                service_name: 'wix.calendar.events.v3.EventsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-calendar.v3,entity=wix.calendar.v3.event,environment=velo-frontend,method-fqn=wix.calendar.events.v3.EventsService.bulkUpdateEvent',
            };
            return universalBulkUpdateEvent(events, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        restoreEventDefaults: (eventId, fields, options) => {
            const methodLogData = {
                method_name: 'restoreEventDefaults',
                service_name: 'wix.calendar.events.v3.EventsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-calendar.v3,entity=wix.calendar.v3.event,environment=velo-frontend,method-fqn=wix.calendar.events.v3.EventsService.restoreEventDefaults',
            };
            return universalRestoreEventDefaults(eventId, fields, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        splitRecurringEvent: (recurringEventId, splitLocalDate, options) => {
            const methodLogData = {
                method_name: 'splitRecurringEvent',
                service_name: 'wix.calendar.events.v3.EventsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-calendar.v3,entity=wix.calendar.v3.event,environment=velo-frontend,method-fqn=wix.calendar.events.v3.EventsService.splitRecurringEvent',
            };
            return universalSplitRecurringEvent(recurringEventId, splitLocalDate, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        cancelEvent: (eventId, options) => {
            const methodLogData = {
                method_name: 'cancelEvent',
                service_name: 'wix.calendar.events.v3.EventsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-calendar.v3,entity=wix.calendar.v3.event,environment=velo-frontend,method-fqn=wix.calendar.events.v3.EventsService.cancelEvent',
            };
            return universalCancelEvent(eventId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkCancelEvent: (eventIds, options) => {
            const methodLogData = {
                method_name: 'bulkCancelEvent',
                service_name: 'wix.calendar.events.v3.EventsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-calendar.v3,entity=wix.calendar.v3.event,environment=velo-frontend,method-fqn=wix.calendar.events.v3.EventsService.bulkCancelEvent',
            };
            return universalBulkCancelEvent(eventIds, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listEventsByContactId: (contactId, options) => {
            const methodLogData = {
                method_name: 'listEventsByContactId',
                service_name: 'wix.calendar.participantevents.v3.ParticipantEventsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-calendar.v3,entity=wix.calendar.v3.event,environment=velo-frontend,method-fqn=wix.calendar.participantevents.v3.ParticipantEventsService.listEventsByContactId',
            };
            return universalListEventsByContactId(contactId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listEventsByMemberId: (memberId, options) => {
            const methodLogData = {
                method_name: 'listEventsByMemberId',
                service_name: 'wix.calendar.participantevents.v3.ParticipantEventsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-calendar.v3,entity=wix.calendar.v3.event,environment=velo-frontend,method-fqn=wix.calendar.participantevents.v3.ParticipantEventsService.listEventsByMemberId',
            };
            return universalListEventsByMemberId(memberId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        Status,
        RecurrenceType,
        Frequency,
        Day,
        Transparency,
        LocationType,
        Role,
        ParticipantsStatus,
        Type,
        Field,
        IdentityType,
        RequestedFields,
        SortOrder,
        WebhookIdentityType,
        PlacementType,
        DayOfWeek,
        ResolutionMethod,
    };
}
//# sourceMappingURL=calendar-v3-event.frontend.js.map